import React from 'react'
import PersonIcon1 from '../../../assets/images/front/users/person-1.png'
import PersonIcon2 from '../../../assets/images/front/users/person-2.png'
import PersonIcon3 from '../../../assets/images/front/users/person-3.png'
import PersonIcon4 from '../../../assets/images/front/users/person-4.png'
import PlaceIcon1 from '../../../assets/images/front/place-1.png'
import PlaceIcon2 from '../../../assets/images/front/place-2.png'
import Contacts from '../../../components/Front/Contacts/Contacts'
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api'

const Contact: React.FC = () => {
  return (
    <>
      <div className="px-4 lg:px-0">
        <div className="container mt-[52px] md:mt-[88px] py-6 md:py-12 mx-4 px-4">
          <h1 className="text-[#0183BA] mb-[60px] text-xl md:text-[25px] text-center">Kontakty</h1>
          <div className="grid grid-cols-12 gap-2 md:gap-4">
            <div className="col-span-6 lg:col-span-3 mb-12 lg:mb-0">
              <div className="px-5 py-7 bg-[#00A0E3] flex flex-col text-center text-white rounded-3xl relative h-full">
                <img
                  src={PersonIcon2}
                  alt=""
                  className="absolute top-[-40px] left-1/2 transform -translate-x-1/2 w-[60px] h-[60px] rounded-full"
                />
                <div className="leading-none">
                  <div className="text-xl md:text-[25px]">MGR. BARBORA VONDROVÁ</div>
                  <div className="text-xl mb-3">PŘÍPRAVNÉ KURZY A ON-LINE KURZY</div>
                </div>

                <div className="font-myriad mt-auto flex flex-col">
                  <a href="tel:+420774504011" className="underline">
                    +420 774 504 011
                  </a>
                  <a href="mailto:info@dohlavy.cz" className="underline">
                    info@dohlavy.cz
                  </a>
                </div>
              </div>
            </div>
            <div className="col-span-6 lg:col-span-3 mb-12 lg:mb-0">
              <div className="px-5 py-7 bg-[#A8CD00] flex flex-col text-center text-white rounded-3xl relative h-full">
                <img
                  src={PersonIcon3}
                  alt=""
                  className="absolute top-[-40px] left-1/2 transform -translate-x-1/2 w-[60px] h-[60px] rounded-full"
                />
                <div className="leading-none">
                  <div className="text-xl md:text-[25px]">Mgr. JOHANA DMOCHOVSKÁ</div>
                  <div className="text-xl mb-3">OSOBNÍ DOUČOVÁNÍ</div>
                </div>
                <div className="font-myriad mt-auto flex flex-col">
                  <a href="tel:+420737577089" className="underline">
                    +420 737 577 089
                  </a>
                  <a href="mailto:johana.dmochovska@dohlavy.cz" className="underline break-words">
                    johana.dmochovska@dohlavy.cz
                  </a>
                </div>
              </div>
            </div>
            <div className="col-span-6 lg:col-span-3">
              <div className="px-5 py-7 bg-[#00A0E3] flex flex-col text-center text-white rounded-3xl relative h-full">
                <img
                  src={PersonIcon1}
                  alt=""
                  className="absolute top-[-40px] left-1/2 transform -translate-x-1/2 w-[60px] h-[60px] rounded-full"
                />
                <div className="leading-none">
                  <div className="text-xl md:text-[25px]">Ing. Jiří Žežulka</div>
                  <div className="text-xl mb-3">Zakladatel</div>
                </div>

                <div className="font-myriad mt-auto flex flex-col">
                  <a href="tel:+420775919901" className="underline">
                    +420 775 919 901
                  </a>
                  <a href="mailto:jiri.zezulka@dohlavy.cz" className="underline">
                    jiri.zezulka@dohlavy.cz
                  </a>
                </div>
              </div>
            </div>
            <div className="col-span-6 lg:col-span-3">
              <div className="px-5 py-7 bg-[#A8CD00] flex flex-col text-center text-white rounded-3xl relative h-full">
                <img
                  src={PersonIcon4}
                  alt=""
                  className="absolute top-[-40px] left-1/2 transform -translate-x-1/2 w-[60px] h-[60px] rounded-full"
                />
                <div className="leading-none">
                  <div className="text-xl md:text-[25px]">Ing. PŘEMYSL MIKA</div>
                  <div className="text-xl mb-3">
                    ROZVOJ FIRMY <br />A ORGANIZACE
                  </div>
                </div>
                <div className="font-myriad mt-auto flex flex-col">
                  <a href="tel:+420603410140" className="underline">
                    +420 603 410 140
                  </a>
                  <a href="mailto:premysl.mika@dohlavy.cz" className="underline break-words">
                    premysl.mika@dohlavy.cz
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full px-4 lg:px-0 py-5 bg-[#00A0E3]">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 lg:col-span-4">
              <h2 className="text-white text-xl md:text-[25px] leading-none mb-3">
                Neklanova 152/42 <br />
                Vyšehrad <br />
                Praha 2
              </h2>
              <div className="grid grid-cols-12 gap-2">
                <div className="col-span-12">
                  <img src={PlaceIcon1} alt="" className="w-full lg:w-[80%] block rounded-lg" />
                </div>
                <div className="col-span-12 flex items-center">
                  <img
                    src={PlaceIcon2}
                    alt=""
                    className="w-full lg:w-[80%] ms-auto block rounded-lg"
                  />
                </div>
              </div>
            </div>
            <div className="col-span-12 lg:col-span-8">
              <LoadScript googleMapsApiKey="AIzaSyBGDTtd2T1qbKaAUV1zAlkyZmxUFNzeA2A">
                <GoogleMap
                  mapContainerClassName="w-full h-full min-h-[300px] rounded-lg"
                  center={{ lat: 50.067019, lng: 14.419729 }} // Neklanova 152/42, Vyšehrad, Praha 2
                  zoom={16}
                >
                  <Marker position={{ lat: 50.067019, lng: 14.419729 }} />
                </GoogleMap>
              </LoadScript>
            </div>
          </div>
        </div>
      </div>
      <Contacts />
    </>
  )
}

export default Contact
